<template>
    <section id="customize_your_interface" class="outer">
        <div class="inner">
            <header class="title">{{ title }}</header>
            <p>{{ content }}</p>
            <div id="intro_keybindings"></div>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                title: 'Customize your interface',
                content: 'On the Mac side, you can set each key on your iOS device. Tito Control not only support in custom key mapping, but also support in combination buttons, hidden buttons and other adjustments. Easily customize your own interface.'
            }
        }
    }
</script>

<style>
    #customize_your_interface {
        padding-top: 40px;
        padding-bottom: 80px;
    }

    #intro_keybindings {
        width: 640px;
        height: 424px;
        background: url('../assets/images/intro_keybindings.png') no-repeat;
        background-size: contain;
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomizeYourInterface.vue